import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { ControlContainer, FormGroup, Validators } from '@angular/forms';
import { ConcessaoTipo } from "@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum";
import { ParentFormGroup } from "app/tools/parent-formgroup";
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: "concessao",
  templateUrl: "./concessao.component.html",
  styleUrls: ["./concessao.component.scss"],
  viewProviders: [ParentFormGroup]
})
export class ConcessaoComponent implements OnInit {
  @Input() tpConcessao: number;
  formGroup: FormGroup;
  constructor(
    private _controlContainer: ControlContainer
  ) {}

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.get('nrConcessao').setValidators([Validators.required, Validators.min(1)]);
    this.formGroup.get('dtInicioConcessao').setValidators([Validators.required]);
    this.formGroup.get('dtVencimentoAlvara').setValidators([Validators.required]);
    this.formGroup.get('tpConcessao').valueChanges.pipe(distinctUntilChanged()).subscribe((valor) => {
      if(valor) {
        this.tpConcessao = valor;
      }
    });
  }

  exibirDataVencimentoAlvara(): boolean {
    return this.tpConcessao === ConcessaoTipo.TAXI || this.tpConcessao === ConcessaoTipo.COMPLEMENTAR;
  }
  
}
